import React, { useEffect, useState } from 'react';
import './index.scss';
import { skinVars, Text6 } from '@telefonica/mistica';
import { useTranslation } from 'react-i18next';
import TabsHome from '../../components/TabsHome';
import useGlobalRequest, { EGlobalRequest } from '../../hooks/useGlobalRequest';
import { ETypeUser } from '../../utils/store/model/store.model';
import Stopper from '../../components/Stopper';
import { TrackingEvents } from '../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../utils/navigation/controlDevices';
import { managementEnvironment } from '../../utils/dataTransformation/environments';
import { getScopeRole } from '../../utils/dataTransformation/role';
import { useGlobalContext } from '../../context/global-context/GlobalContext';

const Home: React.FC = () => {
    const { t } = useTranslation();
    const { trackingScreenView } = new TrackingEvents();
    const { context, setContext } = useGlobalContext();
    const [user] = useGlobalRequest(EGlobalRequest.USER);
    const typeUser = new URLSearchParams(window.location.search).get('clientType');
    const clientType = typeUser;
    const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        if (!(isWebviewAndroid && isWebviewIOS)) {
            trackingScreenView();
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        getScopeRole()
            .then((response) => {
                const islight = response === ETypeUser.LIGHT;
                window.localStorage.setItem('scope', JSON.stringify(response));
                if (islight) setContext({ ...context, typeUser: response });
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    const handleMessageWelcome = () => {
        const date: Number = new Date().getHours();
        const morning: Number[] = [7, 8, 9, 10, 11, 12];
        const evening: Number[] = [13, 14, 15, 16, 17, 18, 19, 20, 21];
        let message: string = '';
        if (morning.includes(date)) {
            message = t('goodMorning');
        } else if (evening.includes(date)) {
            message = t('goodEvening');
        } else {
            message = t('goodNight');
        }

        return message;
    };

    const homeDisabled = managementEnvironment().VITE_STOPPER_HOME_DISABLED;

    return (
        <div className='home-page'>
            {!(isWebviewAndroid || isWebviewIOS) && (
                <div
                    className='home-page__header'
                    style={{
                        background: skinVars.colors.navigationBarBackground,
                        display: clientType === ETypeUser.PRECLIENT ? 'flex' : windowWidth >= 1024 ? 'none' : 'flex',
                    }}
                >
                    <Text6 color={skinVars.colors.textPrimaryInverse}>
                        {user?.name ? `${handleMessageWelcome()}, ${user?.name!}` : `${handleMessageWelcome()}`}
                    </Text6>
                </div>
            )}
            {homeDisabled ? <Stopper></Stopper> : <TabsHome></TabsHome>}
        </div>
    );
};

export default Home;
